/* eslint-disable no-restricted-globals */
import { TextField } from '@material-ui/core';
import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { convertQuatreManufacturer } from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import { compareTwoDatesGreaterThanOrEqual } from '../../../../../SharedModules/DateUtilities/DateUtilities';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import { autoFormateDate } from '../../../../../SharedModules/utilities/utilities';

export function IDTextbox({ cellInfo, isReadOnly = false,onBlurValidation }) {
  const validateTrigger =
    useSelector((state) => state.sharedState.CGPReducer?.validateTrigger) ??
    false;
  let errorField = false;
  if (validateTrigger) {
    if (!cellInfo.value || !String(cellInfo.value).trim()) {
      errorField = true;
    }
  }
  return (
    <div
      className={`fullWidth w-60 text-left td-active-cell ${
        errorField ? 'tBill-validate' : ''
      }`}
    >
      <label className="m-0 hide-elm" htmlFor={`cgp_id_${cellInfo.rowIndex}`}>
        <span>label</span>{' '}
      </label>
      <TextField
        fullWidth
        placeholder=""
        inputProps={{ maxLength: 10 }}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isReadOnly || !!cellInfo.data.addedUserId || false}
        onFocus={(e) => {
          const agGridBody = e.currentTarget.closest('.ag-body-viewport');
          if (agGridBody) {
            agGridBody
              .querySelectorAll('.ag-row-selected')
              .forEach((b) => b.classList.remove('ag-row-selected'));
          }
          e.currentTarget.closest('.ag-row').classList.add('ag-row-selected');
        }}
        onChange={(e) => {
          cellInfo.node.setDataValue(cellInfo.column.colId, e.target.value);
        }}
        onBlur={(e)=>{
          cellInfo.data.newOrUpdateRecord = true
          if(onBlurValidation){
            onBlurValidation(cellInfo.data,cellInfo.rowIndex,'groupingColumnValue')
          }
        }}
        value={cellInfo.value}
        id={`cgp_id_${cellInfo.rowIndex}`}
      />
    </div>
  );
}

export function GroupNumTextbox({ cellInfo, isReadOnly = false ,onBlurValidation}) {
  let errorField = false;
  const validateTrigger =
    useSelector((state) => state.sharedState.CGPReducer?.validateTrigger) ??
    false;
  if (validateTrigger) {
    if (!cellInfo.value || !String(cellInfo.value).trim()) {
      errorField = true;
    }
    if (
      Number(cellInfo.value) !== 99 &&
      (isNaN(Number(cellInfo.value)) ||
        Number(cellInfo.value) < 1 ||
        Number(cellInfo.value) > 10)
    ) {
      errorField = true;
    }
  }
  return (
    <div
      className={`fullWidth w-60 text-left td-active-cell ${
        errorField ? 'tBill-validate' : ''
      }`}
    >
      <label
        className="m-0 hide-elm"
        htmlFor={`cgp_group_number_${cellInfo.rowIndex}`}
      >
        <span>label</span>{' '}
      </label>
      <TextField
        fullWidth
        placeholder=""
        inputProps={{ maxLength: 2 }}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isReadOnly || !!cellInfo.data.addedUserId || false}
        onFocus={(e) => {
          const agGridBody = e.currentTarget.closest('.ag-body-viewport');
          if (agGridBody) {
            agGridBody
              .querySelectorAll('.ag-row-selected')
              .forEach((b) => b.classList.remove('ag-row-selected'));
          }
          e.currentTarget.closest('.ag-row').classList.add('ag-row-selected');
        }}
        onChange={(e) => {
          cellInfo.node.setDataValue(cellInfo.column.colId, e.target.value);
        }}
        onBlur={(e)=>{
          cellInfo.data.newOrUpdateRecord = true
          if(onBlurValidation){
            onBlurValidation(cellInfo.data,cellInfo.rowIndex,'groupNum')
          }
        }}
        value={cellInfo.value}
        id={`cgp_group_number_${cellInfo.rowIndex}`}
      />
    </div>
  );
}

export function ReportingHeaderTextbox({ cellInfo, isReadOnly = false,onBlurValidation }) {
  return (
    <div className="fullWidth w-60 text-left td-active-cell">
      <label
        className="m-0 hide-elm"
        htmlFor={`cgp_reporting_header_${cellInfo.rowIndex}`}
      >
        <span>label</span>{' '}
      </label>
      <TextField
        fullWidth
        placeholder=""
        inputProps={{
          maxLength: cellInfo.colDef.cellEditorParams?.maxLength ?? 20,
        }}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isReadOnly}
        onFocus={(e) => {
          const agGridBody = e.currentTarget.closest('.ag-body-viewport');
          if (agGridBody) {
            agGridBody
              .querySelectorAll('.ag-row-selected')
              .forEach((b) => b.classList.remove('ag-row-selected'));
          }
          e.currentTarget.closest('.ag-row').classList.add('ag-row-selected');
        }}
        onChange={(e) => {
          cellInfo.node.setDataValue(cellInfo.column.colId, e.target.value);
        }}
        onBlur={(e)=>{
          cellInfo.data.newOrUpdateRecord = true
          if(onBlurValidation){
            onBlurValidation(cellInfo.data,cellInfo.rowIndex,'groupHeader')
          }
        }}
        value={cellInfo.value}
        id={`cgp_reporting_header_${cellInfo.rowIndex}`}
      />
    </div>
  );
}

export function StartQtrTextbox({ cellInfo, isReadOnly = false ,onBlurValidation}) {
  let errorField = false;
  const validateTrigger =
    useSelector((state) => state.sharedState.CGPReducer?.validateTrigger) ??
    false;
  if (validateTrigger) {
    const startQtrDate = convertQuatreManufacturer(cellInfo.value);
    if (!cellInfo.value || !String(cellInfo.value).trim() || !startQtrDate) {
      errorField = true;
    }
  }
  return (
    <div
      className={`fullWidth w-60 text-left td-active-cell ${
        errorField ? 'tBill-validate' : ''
      }`}
    >
      <label
        className="m-0 hide-elm"
        htmlFor={`cgp_start_quarter_${cellInfo.rowIndex}`}
      >
        <span>label</span>{' '}
      </label>
      <TextField
        className={
          cellInfo.node.selected && cellInfo.data.startQtr === ''
            ? 'td-active-cell tBill-validate'
            : ''
        }
        fullWidth
        disabled={isReadOnly || !!cellInfo.data.addedUserId || false}
        placeholder=""
        inputProps={{ maxLength: 6 }}
        InputLabelProps={{
          shrink: true,
        }}
        onFocus={(e) => {
          const agGridBody = e.currentTarget.closest('.ag-body-viewport');
          if (agGridBody) {
            agGridBody
              .querySelectorAll('.ag-row-selected')
              .forEach((b) => b.classList.remove('ag-row-selected'));
          }
          e.currentTarget.closest('.ag-row').classList.add('ag-row-selected');
        }}
        onChange={(e) => {
          cellInfo.node.setDataValue(cellInfo.column.colId, e.target.value);
        }}
        onBlur={(e) => {
          cellInfo.node.setDataValue(
            cellInfo.column.colId,
            autoFormateDate(e.target.value?.toUpperCase())
          );
          if(onBlurValidation){
            onBlurValidation(cellInfo.data,cellInfo.rowIndex,'startQtr')
          }
        }}
        value={cellInfo.value}
        id={`cgp_start_quarter_${cellInfo.rowIndex}`}
      />
    </div>
  );
}

export function EndQtrTextbox({ cellInfo, isReadOnly = false, addAction }) {
  let errorField = false;
  const validateTrigger =
    useSelector((state) => state.sharedState.CGPReducer?.validateTrigger) ??
    false;
  const editedData =
    useSelector((state) => state.sharedState.CGPReducer?.tableEditedData) ?? [];
  if (validateTrigger) {
    const endQtrDate = convertQuatreManufacturer(cellInfo.value);
    if (cellInfo.value && !endQtrDate) {
      errorField = true;
    } else if (cellInfo.value) {
      const startQtrDate = convertQuatreManufacturer(
        cellInfo?.node?.data?.startQtr
      );
      if (
        startQtrDate &&
        compareTwoDatesGreaterThanOrEqual(
          new Date(endQtrDate),
          new Date(startQtrDate)
        )
      ) {
        errorField = true;
      }
    }
  }
  return (
    <div
      className={`fullWidth w-60 text-left td-active-cell ${
        errorField ? 'tBill-validate' : ''
      }`}
    >
      <label
        className="m-0 hide-elm"
        htmlFor={`cgp_end_quarter_${cellInfo.rowIndex}`}
      >
        <span>label</span>{' '}
      </label>
      <TextField
        fullWidth
        placeholder=""
        inputProps={{ maxLength: 6 }}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isReadOnly}
        onFocus={(e) => {
          const agGridBody = e.currentTarget.closest('.ag-body-viewport');
          if (agGridBody) {
            agGridBody
              .querySelectorAll('.ag-row-selected')
              .forEach((b) => b.classList.remove('ag-row-selected'));
          }
          e.currentTarget.closest('.ag-row').classList.add('ag-row-selected');
        }}
        onChange={(e) => {
          cellInfo.node.setDataValue(cellInfo.column.colId, e.target.value);
        }}
        onBlur={(e) => {
          cellInfo.node.setDataValue(
            cellInfo.column.colId,
            autoFormateDate(e.target.value?.toUpperCase())
          );
        }}
        onKeyDown={(e) => {
          // if ((e.key === 'Tab' && !e.shiftKey) || e.key === 'ArrowRight') {
          // addAction(e, editedData);
          // }
        }}
        value={cellInfo.value}
        id={`cgp_end_quarter_${cellInfo.rowIndex}`}
      />
    </div>
  );
}

export function DeleteBoxRender(props) {
  const { isReadOnly } = props;
  const selectedParentInd = useSelector(
    (state) => state?.sharedState?.CodeTableReducer?.selectedParentInd
  );
  return (
    <div className="tdCell icon-btn-group text-black d-flex mh-100 h-100 align-items-center">
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="delete-tooltip">Delete</Tooltip>}
      >
        <Button
          data-testid="deleteBtn"
          className="th-ic trash-blue"
          variant="text"
          disabled={isReadOnly || !!(selectedParentInd === '1')}
          onClick={() => props.onClick(props)}
          aria-label="Delete"
        >
          <SVGComponent iconName="Icon-delete" />
        </Button>
      </OverlayTrigger>
    </div>
  );
}
